<template>
  <div
    class="tw-grid tw-grid-cols-3 tw-gap-x-6 tw-gap-y-4 lg:tw-grid-cols-5 lg:tw-gap-6"
  >
    <div
      v-for="(item, index) in items"
      :key="`client-index-${index}`"
      class="tw-col-span-1 tw-flex tw-items-center tw-justify-center"
    >
      <NuxtLink
        v-if="item.link"
        :to="item.link"
        :title="item.title"
        :target="item.link ? '_blank' : '_self'"
        class="tw-flex tw-h-[98px] tw-w-full tw-items-center tw-justify-center tw-transition-transform hover:tw-scale-105 sm:tw-h-24 lg:tw-h-[100px] lg:tw-w-[100px]"
        @click="onLogoClick(item.title)"
      >
        <MediaImageLazyLoad
          :src="item.image?.small || ''"
          :alt="item.title"
          fit="contain"
          :blank-src="item.image.tiny"
          class="tw-max-h-full tw-w-full tw-h-full tw-object-contain"
        />
      </NuxtLink>
      <div
        v-else
        class="tw-flex tw-h-[98px] tw-w-full tw-items-center tw-justify-center sm:tw-h-24 lg:tw-h-[100px] lg:tw-w-[100px]"
      >
        <MediaImageLazyLoad
          :src="item.image?.small || ''"
          :alt="item.title"
          fit="contain"
          :blank-src="item.image.tiny"
          class="tw-max-h-full tw-w-full tw-h-full tw-object-contain"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  items: ClientMeta[];
}>();

const { analyticEvent, fbPixelEvent } = useAnalytic();
const onLogoClick = (title: string) => {
  analyticEvent({
    ga4ActionName: "click_logo",
    ga4Label: title,
  });
  fbPixelEvent({
    fbCategory: "trackCustom",
    fbEvent: "Logo - Home",
    fbValue: { label: title },
  });
};
</script>
